import { render, staticRenderFns } from "./customer-venue-modify.vue?vue&type=template&id=df25b96e&"
import script from "./customer-venue-modify.vue?vue&type=script&lang=js&"
export * from "./customer-venue-modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports